export default "__VITE_ASSET__DFaQpVdJ__"